export default {
  description: '{{name}} kaupungissa {{city}}. Virallinen ruokalista. Säästä rahaa ja tilaa täältä verkossa.',
};
